import { render, staticRenderFns } from "./FeatureLinkedForm.vue?vue&type=template&id=5d644680"
import script from "./FeatureLinkedForm.vue?vue&type=script&lang=js"
export * from "./FeatureLinkedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports